import { languageMap } from "../core"
import { bracketIndenting } from "./shared"

languageMap.graphql = bracketIndenting({ line: "#" })
